/**
 * Catálogo oficial Carioca Barbershop (serviços + barbeiros).
 * Imagens em /public/servicos/{imagem}.png|jpg
 */

import type { BarbeariaBarbeiro, BarbeariaServico } from './barbeariaTipos';

export const CATALOGO_VERSAO = 3;

export const SERVICOS_OFICIAIS: BarbeariaServico[] = [
  {
    id: 'srv-barba',
    nome: 'Barba',
    preco: 30,
    duracaoMin: 40,
    ativo: true,
    categoria: 'Barba',
    imagem: 'barba',
  },
  {
    id: 'srv-degrade',
    nome: 'Degrade',
    preco: 45,
    duracaoMin: 40,
    ativo: true,
    categoria: 'Cabelo',
    imagem: 'degrade',
  },
  {
    id: 'srv-degrade-navalhado',
    nome: 'Degrade Navalhado',
    preco: 50,
    duracaoMin: 40,
    ativo: true,
    categoria: 'Cabelo',
    imagem: 'degrade-navalhado',
  },
  {
    id: 'srv-corte-barba',
    nome: 'Corte+Barba',
    preco: 85,
    duracaoMin: 80,
    ativo: true,
    categoria: 'Combo',
    imagem: 'corte-barba',
  },
  {
    id: 'srv-bigode',
    nome: 'Bigode',
    preco: 5,
    duracaoMin: 5,
    ativo: true,
    categoria: 'Barba',
    imagem: 'bigode',
  },
  {
    id: 'srv-depilacao-nasal',
    nome: 'Depilação Nasal',
    preco: 15,
    duracaoMin: 5,
    ativo: true,
    categoria: 'Extra',
    imagem: 'depilacao-nasal',
  },
  {
    id: 'srv-luzes',
    nome: 'Luzes',
    preco: 80,
    duracaoMin: 30,
    ativo: true,
    categoria: 'Química',
    imagem: 'luzes',
  },
  {
    id: 'srv-pigmentacao',
    nome: 'Pigmentação',
    preco: 25,
    duracaoMin: 15,
    ativo: true,
    categoria: 'Química',
    imagem: 'pigmentacao',
  },
  {
    id: 'srv-platinado',
    nome: 'Platinado',
    preco: 120,
    duracaoMin: 30,
    ativo: true,
    categoria: 'Química',
    imagem: 'platinado',
  },
];

export function barbeirosOficiais(agora: string): BarbeariaBarbeiro[] {
  return [
    {
      id: 'brb-carioca',
      nome: 'CARIOCA',
      ativo: true,
      comissaoPct: 50,
      criadoEm: agora,
    },
    {
      id: 'brb-sub',
      nome: 'SUB',
      ativo: true,
      comissaoPct: 50,
      criadoEm: agora,
    },
  ];
}

/** URL pública do ícone do serviço (pasta public/servicos). */
export function urlImagemServico(imagem?: string): string | null {
  if (!imagem) return null;
  const base = String(imagem).replace(/\.(png|jpe?g|webp)$/i, '');
  return `./servicos/${base}.png`;
}

/** Ordem de tentativa (slug, maiúsculas e nomes originais do usuário). */
export function urlImagemServicoFallback(imagem?: string): string[] {
  if (!imagem) return [];
  const base = String(imagem).replace(/\.(png|jpe?g|webp)$/i, '');
  const upper = base.toUpperCase();
  const extras: Record<string, string[]> = {
    barba: ['BARBA'],
    bigode: ['BIGODE', 'BIGODÊ'],
    'corte-barba': ['CORTE+BARBA', 'CORTE BARBA'],
    degrade: ['DEGRADE', 'DEGRADÊ'],
    'degrade-navalhado': ['DEGRADÊ NAVALHADO', 'DEGRADE NAVALHADO'],
    'depilacao-nasal': ['DEPILAÇÃO NASAL', 'DEPILACAO NASAL'],
    luzes: ['LUZES'],
    pigmentacao: ['PIGMENTAÇÃO', 'PIGMENTACAO'],
    platinado: ['PLATINADO'],
  };
  const nomes = [base, upper, ...(extras[base] || [])];
  const out: string[] = [];
  for (const n of nomes) {
    for (const ext of ['png', 'jpg', 'jpeg', 'webp', 'PNG', 'JPG']) {
      out.push(`./servicos/${n}.${ext}`);
    }
  }
  return out;
}
